import { useCallback, useEffect, useRef, useState } from '@wordpress/element';
import { getGiveawayPlacements } from './giveawayApi';

export default function useGiveawayPlacements() {
    const [placements, setPlacements] = useState({});
    const requestIdRef = useRef(0);

    const refreshPlacements = useCallback(async () => {
        const requestId = ++requestIdRef.current;

        try {
            const data = await getGiveawayPlacements();

            if (requestId !== requestIdRef.current) return;

            setPlacements(data?.placements || {});
        } catch (error) {
            if (requestId !== requestIdRef.current) return;
            setPlacements({});
        }
    }, []);

    useEffect(() => {
        refreshPlacements();

        window.addEventListener('bjnt:giveaway-login', refreshPlacements);
        window.addEventListener('bjnt:giveaway-collected', refreshPlacements);
        window.addEventListener('bjnt:giveaway-refresh', refreshPlacements);

        return () => {
            window.removeEventListener('bjnt:giveaway-login', refreshPlacements);
            window.removeEventListener('bjnt:giveaway-collected', refreshPlacements);
            window.removeEventListener('bjnt:giveaway-refresh', refreshPlacements);
        };
    }, [refreshPlacements]);

    return placements;
}
